export default __webpack_public_path__ + "static/media/courses5.9b642b3e.svg";